<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <div class="me-2 mb-2">
            <a
              href="javascript:void(0);"
              class="btn btn-white d-inline-flex align-items-center"
              data-bs-toggle="modal"
              data-bs-target="#department_csv_import_modal"
              v-can="'Department.Create'"
            >
              <i class="ti ti-file-import me-1"></i>Import
            </a>
          </div>
          <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="exportPDF"
                  >
                    <i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="exportCSV"
                  >
                    <i class="ti ti-file-type-xls me-1"></i>Export as Excel
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="mb-2">
            <a
              href="javascript:void(0);"
              data-bs-toggle="modal"
              data-bs-target="#add_department"
              class="btn btn-primary d-flex align-items-center"
              v-can="'Department.Create'"
              ><i class="ti ti-circle-plus me-2"></i>Add Department</a
            >
          </div>
          <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              class=""
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- Department List -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Department List</h5>
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
          >
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                {{ statusLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="changeStatus('Active')"
                    >Active</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="changeStatus('Inactive')"
                    >Inactive</a
                  >
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="changeStatus('')"
                    >All</a
                  >
                </li>
              </ul>
            </div>

            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort By : {{ sortLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setSort('recent')"
                    >Recently Added</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setSort('asc')"
                    >Ascending</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setSort('desc')"
                    >Descending</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setSort('last_month')"
                    >Last Month</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setSort('last_7_days')"
                    >Last 7 Days</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <a-table
              class="table datatable thead-light"
              :columns="columns"
              :data-source="data"
              :loading="loading"
              row-key="id"
              :row-selection="rowSelection"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'Department'">
                  <h6 class="fw-medium">
                    <a href="javascript:void(0);">{{ record.Department }}</a>
                  </h6>
                </template>
                <template v-if="column.key === 'Status'">
                  <span
                    :class="[
                      'badge',
                      record.Status === 'Active'
                        ? 'badge-success'
                        : record.Status === 'Inactive'
                        ? 'badge-danger'
                        : 'd-inline-flex',
                      'align-items-center',
                      'badge-xs',
                    ]"
                  >
                    <i class="ti ti-point-filled me-1"></i>
                    {{ record.Status }}
                  </span>
                </template>
                <!-- NoofEmployees column intentionally left blank -->
                <template v-if="column.key === 'action'">
                  <div class="action-icon d-inline-flex">
                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      data-bs-toggle="modal"
                      data-bs-target="#edit_department"
                      @click="openEdit(record)"
                      v-can="'Department.Edit'"
                      ><i class="ti ti-edit"></i
                    ></a>
                    <a
                      href="javascript:void(0);"
                      data-bs-toggle="modal"
                      data-bs-target="#delete_modal"
                      @click="openDelete(record)"
                      v-can="'Department.Delete'"
                      ><i class="ti ti-trash"></i
                    ></a>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /Department List -->
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2025 &copy; DoneQuick Hrms.</p>
      <p>
        Powered by
        <a href="javascript:void(0);" class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>

  <DepartmentModal ref="departmentModal" @refresh="() => fetchDepartments(true)" />
  <CsvImportModal
    modal-id="department_csv_import_modal"
    title="Import Departments from CSV"
    description="Upload a CSV to create departments. Existing names are skipped unless you choose update mode."
    template-hint="Columns: Name, Status (Active/Inactive)."
    template-filename="department-import-template.csv"
    :columns="importColumns"
    :download-template-fn="downloadDepartmentTemplate"
    :preview-fn="previewDepartmentImport"
    :apply-fn="applyDepartmentImport"
    @imported="onDepartmentsImported"
  />
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useDepartmentStore } from "@/stores/departmentStore";
import DepartmentModal from "@/components/modal/department-modal.vue";
import CsvImportModal from "@/components/modal/csv-import-modal.vue";
import departmentService from "@/services/hrm/departmentService";

const importColumns = [
  { key: "line", title: "Line" },
  { key: "name", title: "Name" },
  { key: "new_status", title: "Status" },
];

function downloadDepartmentTemplate() {
  return departmentService.downloadImportTemplate();
}
function previewDepartmentImport(file, mode) {
  return departmentService.previewImport(file, mode);
}
function applyDepartmentImport(file, mode) {
  return departmentService.applyImport(file, mode);
}

// Columns definition
const columns = [
  { sorter: false },
  {
    title: "Department",
    dataIndex: "Department",
    key: "Department",
    sorter: {
      compare: (a, b) => {
        a = (a.Department || "").toLowerCase();
        b = (b.Department || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "No of Employees",
    dataIndex: "NoofEmployees",
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
    sorter: {
      compare: (a, b) => {
        a = (a.Status || "").toLowerCase();
        b = (b.Status || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  { title: "", key: "action", sorter: true },
];

// Pinia store
const departmentStore = useDepartmentStore();
const loading = computed(() => departmentStore.loading);
const departmentModal = ref(null);

// 🔹 Filters that we send to backend
const filters = ref({
  status: "", // 'Active' | 'Inactive' | ''
  sort: "recent", // 'recent' | 'asc' | 'desc'
  period: "", // '' | 'last_7_days' | 'last_month' (optional created-at filter)
});

// 🔹 Status label for dropdown
const statusLabel = computed(() => {
  return filters.value.status || "Status";
});

// 🔹 Sort label for dropdown
const sortLabel = computed(() => {
  if (filters.value.period === "last_7_days") return "Last 7 Days";
  if (filters.value.period === "last_month") return "Last Month";

  if (filters.value.sort === "asc") return "Ascending";
  if (filters.value.sort === "desc") return "Descending";

  return "Recently Added";
});

// Table data: map API response → table rows
const data = computed(() =>
  departmentStore.departments.map((dept) => ({
    Department: dept?.name || dept?.Department || "",
    Status: dept?.status || dept?.Status || "",
    NoofEmployees: dept?.employees_count ?? 0,
    id: dept?.id,
  }))
);

// Row selection (stub)
const rowSelection = {
  onChange: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
};

const title = ref("Departments");
const text = ref("Employees");
const text1 = ref("Departments");

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

// 🔹 Central fetch that always uses filters
function fetchDepartments(force = false) {
  departmentStore.fetchDepartments({
    status: filters.value.status || undefined,
    sort: filters.value.sort || undefined,
    period: filters.value.period || undefined,
    force,
  });
}

function onDepartmentsImported() {
  fetchDepartments(true);
}

// 🔹 Handle status filter click
function changeStatus(status) {
  filters.value.status = status;
  fetchDepartments();
}

// 🔹 Handle sort dropdown options
function setSort(option) {
  switch (option) {
    case "recent":
      filters.value.sort = "recent";
      filters.value.period = "";
      break;
    case "asc":
      filters.value.sort = "asc";
      filters.value.period = "";
      break;
    case "desc":
      filters.value.sort = "desc";
      filters.value.period = "";
      break;
    case "last_month":
      filters.value.sort = "recent";
      filters.value.period = "last_month";
      break;
    case "last_7_days":
      filters.value.sort = "recent";
      filters.value.period = "last_7_days";
      break;
  }
  fetchDepartments();
}

// Edit + Delete modals
function openEdit(record) {
  departmentModal.value?.openEditModal(record);
}

function openDelete(record) {
  departmentModal.value?.openDeleteModal(record);
}

function exportCSV() {
  departmentStore.downloadReport("xlsx", buildExportParams());
}

function exportPDF() {
  departmentStore.downloadReport("pdf", buildExportParams());
}

function buildExportParams() {
  return {
    status: filters.value.status || "",
    sort: filters.value.sort || "recent",
    period: filters.value.period || "",
  };
}

// Initial load
onMounted(() => {
  fetchDepartments();
});
</script>

